(function ($) {
  DJ.addBehavior('articleAccordion', '.accordion-items', {
    attach: function () {
      const $this = jQuery(this);

      $this.on('click', 'li', function () {
        $(this).toggleClass('active');
        $(this).siblings().removeClass('active');
        $('.accordion-content').stop().slideUp();
        $('.active .accordion-content').stop().slideDown();
      });
    }
  });
})(jQuery);
